import { useTranslation } from 'react-i18next';
import { SuccessIcon } from '../Icons';
import * as S from './styled';
import { useLayoutEffect, useState } from 'react';
import { sendAnalyticsEvents } from '../../../../analytics/common';
import { EVENTS } from '../../../../analytics/events';
import { AppButton } from '../../../../components';

export const SuccessPopup = ({
	handleSuccessContinue,
	isVisible,
}) => {
	const { t } = useTranslation();
	const [initEventSent, setInitEventStatus] = useState(false);
	useLayoutEffect(() => {
		if (initEventSent) return;
		sendAnalyticsEvents(`${EVENTS.popupEvent}__screen__load`, {
      screen__load: 'success',
    });
		setInitEventStatus(true);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [initEventSent]);

	return (
      <>
        <S.Overlay $isVisible={isVisible} />
        <S.SuccessPopupWrapper>
          <SuccessIcon />
          <S.SuccessText>{t('success_payment')}</S.SuccessText>
          <S.SuccessSubText>{t('payment_received')}</S.SuccessSubText>
          <AppButton
            mt={32}
            staticPosition
            customId="success-popup-continue"
            onClick={handleSuccessContinue}
            displayStubBtn={false}
          >
            {t('continue')}
          </AppButton>
        </S.SuccessPopupWrapper>
        </>
    );
};